import {
  ICreateWidgetFormSchemaInput,
  createCommonFormSchema,
  setComputedNumberTransform,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { IBurdenWidget } from './IBurdenWidget';

export const BurdenWidgetMetaKeys = {
  WidgetId: 'burdenWidget_widgetId',
  MacroBurdenTypeId: 'burdenWidget_macroBurdenTypeId',
};

export function createBurdenWidgetFormSchema({
  widget,
  parentScope,
}: ICreateWidgetFormSchemaInput<IBurdenWidget>) {
  return createCommonFormSchema(
    setComputedNumberTransform(
      widget,
      parentScope,
      yup
        .number()
        .notRequired()
        .meta({
          [BurdenWidgetMetaKeys.WidgetId]: widget.id,
          [BurdenWidgetMetaKeys.MacroBurdenTypeId]: widget.macroBurdenTypeId,
        }),
    ),
    widget,
  );
}
